export const buttonCss = ({ className, overrideCss, theme, size, variant, disabled, }) => {
    const generateClasses = [];
    if (!overrideCss)
        generateClasses.push('button-wrapper');
    if (className)
        generateClasses.push(className);
    const options = [];
    if (theme)
        options.push(theme);
    if (size)
        options.push(size);
    if (variant)
        options.push(variant);
    const baseButtonCss = [];
    const baseButtonText = [];
    const baseButtonIcon = [];
    generateClasses.forEach((cssClass) => {
        baseButtonCss.push(`${cssClass}`);
        baseButtonText.push(`${cssClass}__text`);
        baseButtonIcon.push(`${cssClass}__icon`);
        if (disabled) {
            baseButtonCss.push(`${cssClass}--disabled`);
            baseButtonText.push(`${cssClass}__text--disabled`);
            baseButtonIcon.push(`${cssClass}__icon--disabled`);
        }
        options.forEach((option) => {
            baseButtonCss.push(`${cssClass}--${option}`);
            baseButtonText.push(`${cssClass}__text--${option}`);
            baseButtonIcon.push(`${cssClass}__icon--${option}`);
        });
    });
    return {
        baseButtonCss: baseButtonCss.join(' '),
        baseButtonText: baseButtonText.join(' '),
        baseButtonIcon: baseButtonIcon.join(' '),
    };
};
//# sourceMappingURL=buttonCss.js.map